export const getParam = (name: string): string | undefined => {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) ?? undefined;
  } catch {
    return undefined;
  }
};
